import { USER_ACCESS_ROLE } from '~/modules/common/enums';
import { useMeContext } from '~/modules/me';

export const getIsEnhancedPMOnly = ({ userAccessRoles, featureFlags }) => {
  const {
    isPsaRmpEnhancedPM2Enabled,
    isPsaRmpTaskAllocation1Enabled
  } = featureFlags;

  const isResourceManagerOrPoolManager = (userAccessRoles || []).some(
    role =>
      role === USER_ACCESS_ROLE.RESOURCE_MANAGER ||
      role === USER_ACCESS_ROLE.RESOURCE_POOL_MANAGER
  );

  const isProjectManager = (userAccessRoles || []).some(
    role =>
      role === USER_ACCESS_ROLE.CLIENT_MANAGER ||
      role === USER_ACCESS_ROLE.PROGRAM_MANAGER ||
      role === USER_ACCESS_ROLE.PROJECT_ADMIN ||
      role === USER_ACCESS_ROLE.PROJECT_MANAGER
  );

  return (
    isPsaRmpEnhancedPM2Enabled &&
    isPsaRmpTaskAllocation1Enabled &&
    isProjectManager &&
    !isResourceManagerOrPoolManager
  );
};

const useIsEnhancedPMOnly = () => {
  const me = useMeContext();

  return getIsEnhancedPMOnly(me);
};

export default useIsEnhancedPMOnly;
